function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  width: 40,
  height: 40,
  rx: 16,
  fill: "#FFEBE6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.1782 17.8125L31.8474 27.4816C32.2733 27.9076 32.2733 28.5784 31.8474 28.9831L29.3981 31.4323C28.9828 31.8476 28.312 31.8476 27.8967 31.4323L18.1956 21.7312C15.7251 22.6577 12.8392 22.1359 10.8585 20.1552C8.40932 17.7166 8.1857 13.8937 10.1664 11.1889L14.2449 15.2674L15.757 13.7659L11.6679 9.66613C14.3833 7.68545 18.1956 7.90908 20.6448 10.3583C22.6574 12.3816 23.1686 15.3207 22.1782 17.8125ZM18.579 19.1116L28.6527 29.1854L29.5898 28.2376L19.5267 18.1745C20.0166 17.5462 20.336 16.8434 20.4638 16.0873C20.73 14.6072 20.2934 13.0205 19.1433 11.8704C18.1317 10.8694 16.8006 10.4009 15.4802 10.4754L18.7706 13.7659L14.2555 18.281L10.9651 14.9905C10.8905 16.311 11.3591 17.6527 12.3707 18.6537C13.4782 19.7612 15.001 20.1978 16.4492 19.9848C17.2053 19.8783 17.9294 19.5908 18.579 19.1116Z",
  fill: "#121221"
});

function SvgMaintenance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/Maintenance.b4c81e43.svg";
export { ForwardRef as ReactComponent };